import { useCreateOrganizationLink } from "../../../hooks/organizations/useOrganizationMutations";
import { Button } from "../../ui/button";

export function CreateLinkButton({ orgId }: { orgId: number }) {
  const createLink = useCreateOrganizationLink();

  const onClick = async () => {
    try {
      const res = await createLink.mutateAsync(orgId);
      // res: { link, token }
    } catch (e) {
      // lỗi đã throw từ api
    }
  };

  return (
    <Button className="button-primary" onClick={onClick} disabled={createLink.isPending}>
      {createLink.isPending ? "Đang tạo..." : "Tạo link"}
    </Button>
  );
}
